import { ToastEvent, ToastTypes } from "./toast.models";

export class ToastEvents {
  public static readonly TOAST_EVENT_NAME = 'toast-event';

  public static dispatchError(title: string, description: string, errorCode?: string): void {
    const event: ToastEvent = {
      type: ToastTypes.ERROR,
      title: title,
      description: description,
      errorCode: errorCode ?? '',
    };

    dispatchEvent(new CustomEvent(
      this.TOAST_EVENT_NAME,
      {
        bubbles: true,
        detail: event,
      }
    ));
  }

  public static dispatchWarning(title: string, description: string): void {
    const event: ToastEvent = {
      type: ToastTypes.WARNING,
      title: title,
      description: description,
    };

    dispatchEvent(new CustomEvent(
      this.TOAST_EVENT_NAME,
      {
        bubbles: true,
        detail: event,
      }
    ));
  }

  public static dispatchSuccess(title: string, description: string): void {
    const event: ToastEvent = {
      type: ToastTypes.SUCCESS,
      title: title,
      description: description,
    };

    dispatchEvent(new CustomEvent(
      this.TOAST_EVENT_NAME,
      {
        bubbles: true,
        detail: event,
      }
    ));
  }
}